<app-header [isUnauthorizedLayout]="true"></app-header>
<div class="inner-page-wrapper">
  <div class="inner-page-content">
    <ng-content />
  </div>
  <app-footer></app-footer>
</div>
